export const WIX_FORMS_NAMESPACE = 'wix.pricing_plans.v1.custom_form';
